import { Filter } from '@anytag/shared-molecules';
import { useYoutubeCMSFilter } from '../hooks';
import { Template, TemplateProps } from './Template';

export interface YoutubeCMSFilterProps extends Omit<TemplateProps, 'onSubmit'> {
  className?: string;
}

export const YoutubeCMSFilter = ({ className, ...templateProps }: YoutubeCMSFilterProps) => {
  const { filter, setFilterForm } = useYoutubeCMSFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <Template {...templateProps} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
